import { render, staticRenderFns } from "./Mouse.vue?vue&type=template&id=52c2964e"
import script from "./Mouse.vue?vue&type=script&lang=js"
export * from "./Mouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports